import './bootstrap';
import { createApp } from 'vue';

const vueApp = createApp();

// Vue Config
vueApp.config.globalProperties.$axios = window.$axios = window.axios;
vueApp.config.globalProperties.$bootstrap = window.bootstrap;

vueApp.component('Signature', require('@/components/Signature').default);

window.VueApp = vueApp.mount('#app');
